import React, { useState, useContext, useEffect, useRef, useMemo } from "react";

import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/inlineLink/inlineLinkIcon.css";
import "../../../ui-styles/list/inlineFiltersList.css";
import "../../../ui-styles/picker/picker.css";
import "../../../ui-styles/list/CardsList.css";
import "../../../ui-styles/search/Search.css";

import DropDown from "../../../lib/ui/dropdown/Dropdown";
import Button from "../../../lib/ui/buttons/Button";
import { LangCtx, PayLoadCtx, RoleCtx } from "../../../lib/context";
import { useParams } from "react-router-dom";
import DoctorsListItem from "./components/DoctorsListItem";
import { getDoctorList } from "../../../actions/users";

//import Specialists from "../../../config/specialization.json"
import DateFnsUtils from "@date-io/date-fns";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import Loader from "../../../lib/ui/loader/Loader";
import NoData from "../../../lib/ui/nodata/NoData";
import CtxDropDown from "../../../lib/ui/dropdown/CtxDropdown";
import { getDepartmentList, getSpecialization } from "../../../actions/configuration";
import { toast } from "react-toastify";
import useDebounce from "../useDebounce";
// import Loading from "../../../components/loading";
import DoctorProfileSlide from "./components/DoctorProfileSlide";
import {API} from 'aws-amplify';
// import { getAxios } from "../../../actions/appointment";

//const Specialists = [{ value: "", label: l.select_spcl, }, { value: "children", label: "Child Specialist" }, { value: "dermatologist", label: "Dermatologist" }, { value: "eyeAndENT", label: "Eye & ENT" },]

const DoctorSchedule = (props) => {
    const { l } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);
    const { payload } = useContext(PayLoadCtx);
    const [searchTerm, setSearchTerm] = useState("");
    // const doctorList = useRef(null);

    const [loading, setLoading] = useState(false);
    const [docloading, setDocLoading] = useState(false);
    const [docTotal, setDocTotal] = useState(0);
    const [more, setMore] = useState(false);
    // const [end, setEnd] = useState(false)
    const [department, setDepartment] = useState({ value: "", id: "" });
    const [departments, setDepartments] = useState([]);

    // const { specializationsList } = useContext(SpecializationsCtx);
    const [changeDate, setChangeDate] = useState(null);
    const [specialization, setSpecialization] = useState({ id: "", value: "" });
    const [specializations, setSpecializations] = useState([
        {
            value: "",
            label: l.select_specialist,
        },
    ]);
    const [filterItems, setFilterItems] = useState([]);
    const [doctors, setDoctors] = useState([]);
// doctor view profile slide
    const [doctorProfileData, setDoctorProfileData] = useState(null);

    const { pId } = useParams();
    // const departments = [{ value: "", label: l.select_department, }, { value: "allopathy", label: "Allopathy" }, { value: "ayurvedic", label: "Ayurvedic" }, { value: "homeopathy", label: "Homeopathy" }, { value: "unani", label: "Unani" }]
    const debouncedSearchTerm = useDebounce(searchTerm, 1000);
   
   
    const [skip, setSkip] = useState(0);
    // const proCardsWrapRef = useRef(null);
    const slideRef = useRef(null);
    const searchRef = useRef("");

    // const scrollThreshold = 100;
    // const [rates, setRates] = useState(null);

    useEffect(() => { 
        loadDoctors();
    }, [debouncedSearchTerm, department, specialization, changeDate, searchTerm])

    useEffect(() => { 
        if(skip!==0){
            loadDoctors();
        }
    }, [skip])


    let query = `?clinicId=${payload?.consultRole === "clinic" ? payload?.userId : payload?.clinicId}&type=all`;

    useEffect(() => {
        setLoading(true);
        getDepartmentList(query)
            .then((res) => {
                if (res.status) {
                    let defaultLabel = [...res?.data];
                    defaultLabel.unshift({
                        name: "",
                        label: l.select_department,
                    });
                    setDepartments(defaultLabel);
                } else {
                    console.log("something");
                }
                setLoading(false);
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    toast.POSITION(err?.response?.data?.error, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setLoading(false);
                }
            });
    }, []);

    useEffect(() => {
        if (!departments.length) {
            setDepartments([{ value: "", label: l.select_department }]);
        }
    }, [departments]);

    useEffect(() => {
        setLoading(true);
        if (department && department?.id !== "") {
            query = query + `&id=${department?.id}`;
        }
        getSpecialization(query)
            .then((res) => {
                if (res.status) {
                    let defaultLabel = [...res?.data];
                    defaultLabel.unshift({
                        name: "",
                        label: l.select_spcl,
                    });
                    setSpecializations(defaultLabel);
                    // filterSpecialization();
                } else {
                    console.log("something");
                }
                setLoading(false);
            })
            .catch((err) => {
                toast.POSITION(err?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setLoading(false);
            });
    }, [department]);

    // useEffect(() => {
    //     setLoading(true);
    //     let _items = [...doctors];
    //     if (department && department.id && department.id !== "" && department.value && department.value !== "") {
    //         _items = _items.filter(
    //             (doctor) => doctor.department?.toUpperCase() === department?.value.toUpperCase() || doctor?.departmentId === department?.id
    //         );
    //     }
    //     if (specialization && specialization.id && specialization.id !== "" && specialization.value && specialization.value !== "") {
    //         _items = _items.filter(
    //             (doctor) =>
    //                 doctor.speciality?.toUpperCase() === specialization.value.toUpperCase() || doctor?.specialityId === specialization?.id
    //         );
    //     }
    //     setFilterItems([..._items]);
    //     setLoading(false);
    // }, [department, specialization, doctors]);

    useEffect(() => {
        if (searchRef.current !== searchTerm) {
            setDocLoading(true);
            searchRef.current = searchTerm;
            loadDoctors();
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        // Add event listener to detect outside clicks
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Clean up event listener on component unmount
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSlideData = (data) =>{
        setDoctorProfileData(data);
    }

    const handleClose = () =>{
        setDoctorProfileData(null);
    }

    const handleClickOutside = (event) => {
        if (slideRef.current && !slideRef.current.contains(event.target)) {
            handleClose();
        }
    };

    const loadmore = () => {
        if(docTotal > doctors.length){
            setSkip((prevSkip) => prevSkip + 1); 
            setMore(true)
        }
    }
   
    const loadDoctors = () => {
        setDocLoading(true);
        let now = new Date();
        let _fdate = undefined;
        let _cdate = now.valueOf();
        let _minutes = now.getHours() * 60 + now.getMinutes();
        let d = now.setMinutes(now.getMinutes() + 30);
        let _d = d.valueOf();
        let _day = now.getDay();
        if (changeDate) {
            _minutes = changeDate.getHours() * 60 + changeDate.getMinutes();
            let selected = new Date(changeDate);
            let filterDate = new Date(changeDate).setHours(0, 0, 0, 0);
            d = new Date(selected.setMinutes(changeDate.getMinutes() + 30));
            _fdate = filterDate.valueOf();
            _cdate = changeDate.valueOf();
            _d = d.valueOf();
            _day = changeDate.getDay();
        }
        let deptId = department.id !== "" ? department.id : ""; 
        let specialityId = specialization.id !== "" ? specialization.id : "";
        const limit = 18; 
        getDoctorList("doctor", _fdate, _cdate, _minutes, _d, _day, "",role === "C" ? payload.userId : payload.clinicId, limit, searchTerm, skip, deptId, specialityId)
            .then((res) => {
                if (res && res.data) {
                    if(more){
                        setFilterItems((prev) => [...prev, ...res.data]);
                        setDoctors((prev) => [...prev, ...res.data]);
                        setMore(false)
                    } else {
                        setFilterItems(res.data);
                        setDoctors(res.data);
                    }
                    setDocTotal(res.count);
                    setSkip(0)
                } else {
                    setDoctors([]); 
                    setFilterItems([]);
                    setDocTotal(0)
                    setSkip(0)
                }             
                setDocLoading(false);
            }).catch(err => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setDocLoading(false);
                }
            });
    };

    // const handleScroll = () => {
    //     if (proCardsWrapRef.current) {
    //         const { bottom } = proCardsWrapRef.current.getBoundingClientRect();
    //         const windowHeight = window.innerHeight;
    //         const scrollThreshold = (windowHeight * 30) / 100
    //         console.log("scrollThreshold", scrollThreshold)
    //         console.log("specs::::",bottom,windowHeight)
    //         if (bottom <= windowHeight + scrollThreshold) {
    //             setEnd(true)
    //         }
    //     }
    // };

    // useEffect(() => {
    //     window.addEventListener("scroll", handleScroll);
    //     return () => {
    //         window.removeEventListener("scroll", handleScroll);
    //     };
    // }, []);

    // useEffect(()=>{
    //     console.log("scrollingggg:::",end ,  docTotal , doctors.length)
    //     if(end &&  docTotal > doctors.length){
    //         loadmore()
    //     }
    // }, [end])

    // const handleSerach = (e) => {
    //     setSearchTerm(e.target.value)
    //     let val = e.target.value.trim();

    //     if (val.length > 1 || val.length == 0) {
    //         let filter = val.toUpperCase();
    //         let li = doctorList.current.getElementsByClassName('proCardBox');
    //         //  let li = parent.getElementsByClassName('listAutoContent');
    //         let searchfound = false;
    //         for (let i = 0; i < li.length; i++) {
    //             let a = li[i].getElementsByClassName("proInfoLTxt")[0];
    //             if (a) {
    //                 let txtValue = a.textContent || a.innerText;
    //                 if (txtValue.toUpperCase().indexOf(filter) > -1) {
    //                     li[i].style.display = "";
    //                     searchfound = true;
    //                 } else {
    //                     li[i].style.display = "none";
    //                 }
    //             }
    //         }
    //     }
    // }


    // const filterSpecialization = () => {
    //     if (department !== "" && department !== null) {
    //         const departobj = departments.find(x => x?.name === department)
    //         console.log("departobj?._id..................:", departobj?._id, specializations)
    //         const specobj = specializations?.filter((each) => each?.departmentIds?.includes(departobj?._id))

    //         console.log(specobj);
    //         if (specobj && specobj.length > 0) {
    //             specobj.unshift({
    //                 name: '',
    //                 label: l.select_spcl
    //             })

    //             console.log(".................",specobj);
    //             setSpecializations(specobj);
    //         }
    //         console.log(specobj);
    //     }
    // }

    // useEffect(() => {
    //     filterSpecialization()
    // }, [department])
    const handleDepartment = (e) => {
        const obj = departments.find((x) => x?.name === e.target.value);
        setDepartment({ id: obj?._id, value: obj?.name });
        setSpecialization({ id: "", value: "" });
    };

    const handleSpeciality = (e) => {
        const obj = specializations.find((x) => x?.name === e.target.value);
        setSpecialization({ id: obj?._id, value: obj?.name });
    };

    // console.log("spec", specializations);

    // const getCurrencies = async () => {
    //     try {
    //         // const res = await axios.get(`https://api.exchangerate-api.com/v4/latest/${currencyCode}`)
    //         // if (res.data) {
    //         //     console.log('ooooo', res.data.rates);
    //         //     setRates(res.data.rates);
    //         // }
    //         let curr = currencyCode.toLowerCase()
    //         getAxios(curr).then((res) => {
    //             console.log("res.data...................:(", JSON.parse(res.data)[curr])
    //             let result = JSON.parse(res.data)[curr]
    //             console.log('res', result);
    //             setRates(result);
    //         }).catch((err) => console.log(err))
    //     }
    //     catch (e) {
    //         console.log('eeeeee', e);
    //     }
    // }

    // useEffect(() => {
    //     if (currencyCode) {
    //         getCurrencies()
    //         console.log("1")
    //     }
    // }, [])

    const doctorCard = useMemo(() => (
        filterItems.map((doctorItem) => (
            <DoctorsListItem
                data={doctorItem}
                key={doctorItem.userId}
                patientId={pId ? pId : null}
                date={changeDate}
                handleSlideData={handleSlideData}
            />
        ))
    ), [filterItems, pId, changeDate, handleSlideData]); 

    return (
        <>
            {/* {loading && <Loading/>} */}
            {/* {docloading && !skip && (
                        <div>
                            <Loader />
                        </div>
            )} */}
            <div className="baseContainer">
                <div className="hdngTopCol colBlock">
                    <div className="hdngTopBox etcPdng">
                        <h2 className="topHdngTxt">{l.book_apptmnt}</h2>
                    </div>
                    <p></p>
                    <div className="searchBlock">
                        <div className="searchBox searchFull">
                            <form method="post" className="searchForm" onSubmit={(e) => e.preventDefault()}>
                                <input
                                    className="textbox"
                                    title="Search"
                                    value={searchTerm}
                                    placeholder={l.search}
                                    type="text"
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </form>
                        </div>
                    </div>
                    <div className="filterRow">
                        <div className="filterGroup">
                            <div className="filterItem">
                                <DropDown
                                    placeholder={l.select_department}
                                    items={departments}
                                    value={department.value}
                                    onChange={handleDepartment} //{e => setDepartment(e.target.value)}
                                    size="selectFullWidth"
                                />
                            </div>
                        </div>
                        <div className="filterGroup">
                            <div className="filterItem">
                                <CtxDropDown
                                    placeholder={l.select_spcl}
                                    items={specializations}
                                    value={specialization.value}
                                    onChange={handleSpeciality} //{e => setSpecialization(e.target.value)}
                                    size="selectFullWidth"
                                />
                            </div>
                        </div>
                        <div className="filterGroup">
                            <div className="filterItem">
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        fullWidth
                                        className="pickerInput"
                                        inputVariant="outlined"
                                        inputProps={{ readOnly: true }}
                                        value={changeDate}
                                        emptyLabel={l.sel_date}
                                        onChange={(date) => date && setChangeDate(date)}
                                        animateYearScrolling
                                        placeholdertext="Date"
                                        format="dd/MM/yyyy"
                                        minDate={new Date()}
                                    />
                                    {/* <div className="inputIconBox"><img src="/images/icons/date.png" alt="date" className="invertGray" /></div> */}
                                </MuiPickersUtilsProvider>
                            </div>
                            {/* <div className="filterItem filterAuto">
                                <Button
                                    label={l.search}
                                    className="btn"
                                    size="sm"
                                    fullWidth="fullWidth"
                                    type="primary"
                                //onClick={search}
                                />
                            </div> */}
                        </div>
                    </div>
                </div>
                {docloading && !skip && (
                        <Loader />
                )}
                <div className="proCardsWrap">  {/*ref={proCardsWrapRef} */}
                    { filterItems && filterItems.length > 0 && 
                        doctorCard
                    }
                    {docTotal > doctors.length && (
                        <div className="rowBlock mrgTop16">
                            <div className="btnTxtGroup flxCenter">
                                {docloading && skip ? (
                                    <Loader centered={false} width="50px" height="50px"/> 
                                ) : (
                                    <Button
                                        label={'load more'}
                                        className="btn"
                                        size="sm"
                                        type="primary"
                                        onClick={loadmore}
                                    />
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {!docloading && filterItems.length === 0 &&
                        <NoData Heading={l.no_doctors} src="/images/icons/doctor-default.png" label="" />}
                {/* <div> */}
                                {/* <span>Page {currentPage}</span>
                                <button onClick={handleNextPage} disabled={currentPage * limit >= totalDoctors}>
                                Next
                                </button> */}
                {/* </div> */}
                {doctorProfileData !== null && (
                     <DoctorProfileSlide 
                     ref={slideRef}
                     open={true} 
                     closeSlide={handleClose} 
                     data={doctorProfileData} 
                     />
                 )}
            </div>
        </>
    );
};
export default DoctorSchedule;
